/* globals EasyPost */
import Backbone from 'backbone';

import { setLocation, location } from 'utils/wrappers';
import { setStoredValue, getStoredValue } from 'utils/storage';

/** * PUBLIC MODULE * **/
const base = Backbone.Router.extend({
  routes: {},
  targetEl: '#content-area',
  loggedIn: true,

  renderView(instance) {
    instance.render();
    const oldView = EasyPost.Globals.currentView;
    if (oldView) {
      oldView.removeSubviews();
      oldView.remove();
      oldView.unbind();
      oldView.undelegateEvents();
    }
    EasyPost.Globals.currentView = instance;
    $('body').find(this.targetEl).html(instance.el);

    // content has been added to page. Run onDomRefresh script
    instance.onDomRefreshBase();
  },

  redirectToHome() {
    setLocation('/');
  },

  redirectToLogin() {
    setLocation('/signin');
  },

  redirectToLoggedIn() {
    setLocation('/account/shipments');
  },

  redirectUnlessLoggedIn(callback = this.redirectToLoggedIn, redirect) {
    if (this.userIsLoggedIn()) {
      return callback();
    }
    if (redirect) {
      Backbone.history.navigate(redirect, {trigger: true, replace: true});
      return false;
    }
    const currentLocation = (location().pathname || '') + (location().hash || '');
    setStoredValue('signinLocation', currentLocation);
    return this.redirectToLogin();
  },

  redirectUnlessLoggedOut(callback = this.redirectToLoggedIn) {
    if (this.userIsLoggedIn()) {
      return callback();
    }
    return EasyPost.Globals.currentUser;
  },

  enforceCheckoutFlow() {
    if (getStoredValue('epsubplan')) {
      return true;
    }
    this.redirectToHome();
    return false;
  },

  enforceLogin(callback, redirect) {
    if (EasyPost.Globals.firstFetchComplete) {
      this.redirectUnlessLoggedIn(callback, redirect);
    } else {
      this.listenToOnce(EasyPost.Globals.currentUser, 'error sync', () => {
        // Backbone listens once for EACH event
        this.stopListening(EasyPost.Globals.currentUser);
        this.redirectUnlessLoggedIn(callback, redirect);
      });
    }
  },

  enforceNotLoggedIn(callback) {
    if (EasyPost.Globals.firstFetchComplete) {
      return this.redirectUnlessLoggedOut(callback);
    }

    EasyPost.Globals.currentUser.once('error sync', this.redirectUnlessLoggedOut.bind(this, callback), this);
    return true;
  },
  checkForHash(substring = 1) {
    return Backbone.history.location.hash.length > 0
        && Backbone.history.location.hash.substring(substring);
  },
  userIsLoggedIn() {
    return EasyPost.Globals.currentUser && EasyPost.Globals.currentUser.isLoggedIn();
  },
});

export default base;



// WEBPACK FOOTER //
// ./app/routers/base.js